import { Component,ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {

  constructor() { }
  
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2/src/app/app.component.ts